var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentMapping[_vm.country],{tag:"component",attrs:{"brandConfig":_vm.brandConfig,"country":_vm.country,"storeId":_vm.storeId,"storeName":_vm.storeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }